import { render } from "./LocationCategories.vue?vue&type=template&id=482cbcb0"
import script from "./LocationCategories.vue?vue&type=script&lang=js"
export * from "./LocationCategories.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__